/**
 * @file LoginPage.js
 * @description Componente da tela de Login para a área de administração.
 */
import React, { useState } from "react";
import { Shield } from "lucide-react"; // Usando um ícone de escudo para o tema

const LoginPage = ({ onLogin, error, setView }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(email, password);
  };

  return (
    <div className="flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full space-y-8 bg-gray-800 p-8 sm:p-10 rounded-xl shadow-2xl">
        <div>
          <Shield className="mx-auto h-12 w-auto text-teal-400" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            Acesso Restrito
          </h2>
          <p className="mt-2 text-center text-sm text-gray-400">
            Área exclusiva para administradores do Desafio.
          </p>
        </div>
        <form
          className="mt-8 space-y-6"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="off"
                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-700 bg-gray-900 placeholder-gray-500 text-white rounded-t-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm"
                placeholder="Email"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Senha
              </label>
              <input
                id="password"
                name="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength="6"
                autoComplete="new-password"
                className="appearance-none rounded-none relative block w-full px-3 py-3 border border-gray-700 bg-gray-900 placeholder-gray-500 text-white rounded-b-md focus:outline-none focus:ring-teal-500 focus:border-teal-500 focus:z-10 sm:text-sm"
                placeholder="Senha"
              />
            </div>
          </div>
          {error && <p className="text-red-500 text-center text-sm">{error}</p>}
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-teal-500"
            >
              Entrar
            </button>
          </div>
        </form>
        <button
          onClick={() => setView("DASHBOARD")}
          className="text-center w-full text-sm text-teal-400 hover:text-teal-300 mt-4"
        >
          Voltar ao Início
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
